import { Component, OnInit, input } from '@angular/core';


@Component({
    selector: 'sidebar-template',
    templateUrl: './sidebartemplate.component.html',
    styleUrls: ['./sidebartemplate.component.scss'],
    standalone: true,
    imports: []
})
export class SidebartemplateComponent implements OnInit {
  readonly showSidebar = input<boolean>(false);
  readonly displayMask = input<boolean>(false);
  readonly top = input<number>(113);

  constructor() { }

  ngOnInit() {
  }
}
